import { CircularProgress } from '@material-ui/core'
import './FullScreenLoader.scss'

export const ComponentFullScreenLoader = () => <div className='ComponentFullScreenLoader'><CircularProgress /></div>